import { render } from "./PopupAdd.vue?vue&type=template&id=bdf15490&scoped=true"
import script from "./PopupAdd.vue?vue&type=script&lang=js"
export * from "./PopupAdd.vue?vue&type=script&lang=js"

import "./PopupAdd.vue?vue&type=style&index=0&id=bdf15490&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf15490"]])

export default __exports__